import instance from 'api/instance';
import { IGetSettings, IUpdateSettings } from './types';

export const getSettings: IGetSettings = () => instance.get('settings');

export const updateSettings: IUpdateSettings = (data) =>
	instance.put('settings', data);
